import { REDUCERS } from '../../constants/reducers';

const initialState = {
  list: [],
  unreadNotificationCount: 0,
  alerts: [],
  selectedAlerts: [],
  selectedFilters: {},
  loading: false
};

const notification = (state = initialState, action) => {
  switch (action.type) {
    case REDUCERS.NOTIFICATION.SET_SELECTED_FILTERS: {
      return Object.assign({}, state, {
        ...state,
        selectedFilters: action.value
      });
    }
    case REDUCERS.NOTIFICATION.SET_NOTIFICATION_STATE: {
      return Object.assign({}, state, {
        ...state,
        ...action.value,
        loading: false
      });
    }
    case REDUCERS.NOTIFICATION.SET_NOTIFICATION_LIST: {
      return Object.assign({}, state, {
        list: [...action.value]
      });
    }
    case REDUCERS.NOTIFICATION.FETCH_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case REDUCERS.NOTIFICATION.FETCH_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case REDUCERS.RESET:
      return initialState;
    default:
      return state;
  }
};

export { notification };
